// @flow
export const SET_COUNTRY_BEACHES_START = 'SET_COUNTRY_BEACHES_START';
export const SET_COUNTRY_BEACHES_SUCCEED =
         'SET_COUNTRY_BEACHES_SUCCEED';
export const SET_COUNTRY_BEACHES_FAILED = 'SET_COUNTRY_BEACHES_FAILED';

export const SET_REGION_BEACHES = 'SET_REGION_BEACHES';

export const SET_MAP_RESULTS_SELECT = 'SET_MAP_RESULTS_SELECT';
export const SET_MAP_RESULTS_INPUT = 'SET_MAP_RESULTS_INPUT';
export const SET_RETURN_FROM_DETAILS = 'SET_RETURN_FROM_DETAILS';

export const SET_MAP_AREA = 'SET_MAP_AREA';

export const SET_NUDISM = 'SET_NUDISM';
export const SET_BLUE_FLAG = 'SET_BLUE_FLAG';
export const SET_SURFING_AREA = 'SET_SURFING_AREA';
export const SET_BEACH_BAR = 'SET_BEACH_BAR';
export const SET_NAUTICS_RENTAL = 'SET_NAUTICS_RENTAL';
export const SET_DIVING_AREA = 'SET_DIVING_AREA';
export const SET_DISABLED_PERSONS = 'SET_DISABLED_PERSONS';
export const SET_OCCUPANCY = 'SET_OCCUPANCY';
export const SET_PROMENADE = 'SET_PROMENADE';
export const SET_HOSPITAL_DISTANCE = 'SET_HOSPITAL_DISTANCE';
export const SET_BEACH_LENGTH = 'SET_BEACH_LENGTH';
export const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT';
export const SET_UMBRELLA_BEACH_RENTAL = 'SET_UMBRELLA_BEACH_RENTAL';
export const SET_SUNBED_RENTAL = 'SET_SUNBED_RENTAL';
export const SET_SELECT_TEXT = 'SET_SELECT_TEXT';
export const SET_RESET = 'SET_RESET';